import { render, staticRenderFns } from "./AffiliatePage.vue?vue&type=template&id=c7f85742&"
import script from "./AffiliatePage.vue?vue&type=script&lang=js&"
export * from "./AffiliatePage.vue?vue&type=script&lang=js&"
import style0 from "./AffiliatePage.vue?vue&type=style&index=0&id=c7f85742&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports